import { render, staticRenderFns } from "./DocsItem.vue?vue&type=template&id=324e0d20&"
import script from "./DocsItem.vue?vue&type=script&lang=js&"
export * from "./DocsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports